
import Dot from '@/components/UntitledUI/Dot.vue'
import Button from '@/components/UntitledUI/Button.vue'
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    name: 'SearchHistoryItem',
    components: { Dot, Button, Icon },
    props: {
        history: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true,
            validator: val => ['search', 'file'].includes(val)
        },
        store: {
            type: String,
            default: 'files'
        },
        feature: {
            type: String,
            default: undefined
        }
    },
    data () {
        return {
            form: new this.$vForm({
                history_type: this.type,
                history_id: this.history.id
            })
        }
    },
    methods: {
        remove () {
            this.form.update({ feature: this.feature })
            this.form.delete('/v1/files/history')
                .then((res) => {
                    this.$store.commit(this.store + '/deleteHistory', { type: this.type, history: this.history })
                })
                .catch((e) => {
                    this.$toast.error(this.$t('general error'))
                })
        },
        to () {
            if (this.type === 'file') {
                return this.localePath('/File/' + this.history.hash)
            }
            return {
                query: {
                    text: this.history.name,
                    main: this.history.tag ? this.history.tag.id : undefined
                }
            }
        }
    }
}
